import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AvgRatingsPipe } from './avg-ratings.pipe';
import { PriceTvaPipe } from './price-to-tva.pipe';
import { TaxiGenreParserPipe } from './taxi_genre_parser.pipe';
import { UserTypeParserPipe } from './usertype_parser.pipe';
// import { ClickDoubleDirective } from '../directives/click-handler.directive';
import { MoneyToLetterPipe } from './number-to-taxi.pipe';
import { CommandErrorPipe } from './command-error-log';

@NgModule({
  imports: [CommonModule,
     AvgRatingsPipe,
    PriceTvaPipe,
    TaxiGenreParserPipe,
    UserTypeParserPipe,
    // ClickDoubleDirective,
    MoneyToLetterPipe,
    CommandErrorPipe,
  ],
  declarations: [
   
  ],
  exports: [
    AvgRatingsPipe,
    PriceTvaPipe,
    TaxiGenreParserPipe,
    UserTypeParserPipe,
    // ClickDoubleDirective,
    MoneyToLetterPipe,
    CommandErrorPipe,
  ],
})
export class PipesModule {}
